import React from 'react'
type Props = {
  onClick: () => void
  title: string
  body: string
  dataUid: string
  src: string
}

const buttonClassNames =
  'transition type-17-demibold text-left w-full bg-white shadow-blackish hover:shadow-subtle transform hover:-translate-y-1 rounded-6 md:px-16 py-16 px-24 py-24 my-8'
const buttonSubTextClassNames = 'block type-14 text-TypeSub mt-4 pl-10'

const SignupGoalOption = ({ onClick, title, body, dataUid, src }: Props) => (
  <button data-uid={dataUid} onClick={onClick} className={buttonClassNames}>
    <div className="ml-10 flex w-full flex-row items-center">
      <img width="45" src={src} />
      <div className="block p-[15px]">
        <p className="quincy pl-10 text-20">{title}</p>
        <p className={buttonSubTextClassNames}>{body}</p>
      </div>
    </div>
  </button>
)

export default SignupGoalOption
